import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more.svg';
import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';
import { useTranslation } from "react-i18next";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { podServiceTypes, probeExecTypes } from "./PodProfileData";
import { serviceTypes } from "../service/PodServiceData";
import StepLine from "../../base/tamplate/StepLine";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import CustomText from "components/base/CustomText";


interface ArgsType {
    projectId: string;
    podProfileId: string;
    podProfileName: string;
    podProfileDesc: string;
    deploymentYn: string;
    deploymentCount: string;
    labels: string;
    annotations: string;
    selector: string;
    templateLabels: string;
    pod_profile_container_id: string;
    pod_profile_container_name: string;
    service_type_code: string;
    request_cpu_count: number;
    request_memory_capacity_mb: number;
    limit_cpu_count: number;
    limit_memory_capacity_mb: number;
    use_gpu_yn: boolean;
    commands: string;
    volume_mounts: string;
    environments: string;
    ports: string;
    liveness_probe_yn: boolean;
    liveness_probe_commands: string;
    liveness_probe_http_get_path: string;
    liveness_probe_http_get_port: number;
    liveness_probe_http_get_headers: string;
    liveness_probe_tcp_socket_port: number;
    liveness_probe_init_delay_sec: number;
    liveness_probe_period_sec: number;
    liveness_probe_timeout_sec: number;
    readiness_probe_yn: boolean;
    readiness_probe_commands: string;
    readiness_probe_http_get_path: string;
    readiness_probe_http_get_port: number;
    readiness_probe_http_get_headers: string;
    readiness_probe_tcp_socket_port: number;
    readiness_probe_init_delay_sec: number;
    readiness_probe_period_sec: number;
    readiness_probe_timeout_sec: number;
    container_image_name: string;
    create_ts: string;
    update_ts: string;
}

interface PodProfileContainerUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

PodProfileContainerUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function PodProfileContainerUpdate(props:PodProfileContainerUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
    
    const [containerName, setContainerName] = useState("");
    const [containerImageName, setContainerImageName] = useState("");
    const [containerImageId, setContainerImageId] = useState("");
    const [containerServiceTypeCode, setContainerServiceTypeCode] = useState("");
    const [resourceYn, setResourceYn] = useState(false);
    const [requestCpuCount, setRequestCpuCount] = useState("0");
    const [requestMemoryCapacityMb, setRequestMemoryCapacityMb] = useState("0");
    const [limitsCpuCount, setLimitsCpuCount] = useState("0");
    const [limitsMemoryCapacityMb, setLimitsMemoryCapacityMb] = useState("0");
    const [gpuYn, setGpuYn] = useState(false);
    const [commands, setCommands] = useState("");
    const [volumeMounts, setVolumeMounts] = useState("");
    const [envs, setEnvs] = useState("");
    const [ports, setPorts] = useState("");
    const [livenessYn, setLivenessYn] = useState(false);
    const [livenessType, setLivenessType] = useState("CMD");
    const [livenessCommands, setLivenessCommands] = useState("");
    const [livenessHttpGetPath, setLivenessHttpGetPath] = useState("");
    const [livenessHttpGetPort, setLivenessHttpGetPort] = useState("80");
    const [livenessHttpGetHeaders, setLivenessHttpGetHeaders] = useState("");
    const [livenessTcpSocketPort, setLivenessTcpSocketPort] = useState("0");
    const [livenessInitialDelaySecond, setLivenessInitialDelaySecond] = useState("30");
    const [livenessPeriodSecond, setLivenessPeriodSecond] = useState("10");
    const [livenessTimeoutSecond, setLivenessTimeoutSecond] = useState("5");

    const [readnessYn, setReadnessYn] = useState(false);
    const [readnessType, setReadnessType] = useState("CMD");
    const [readnessCommands, setReadnessCommands] = useState("");
    const [readnessHttpGetPath, setReadnessHttpGetPath] = useState("");
    const [readnessHttpGetPort, setReadnessHttpGetPort] = useState("80");
    const [readnessHttpGetHeaders, setReadnessHttpGetHeaders] = useState("");
    const [readnessTcpSocketPort, setReadnessTcpSocketPort] = useState("0");
    const [readnessInitialDelaySecond, setReadnessInitialDelaySecond] = useState("30");
    const [readnessPeriodSecond, setReadnessPeriodSecond] = useState("10");
    const [readnessTimeoutSecond, setReadnessTimeoutSecond] = useState("5");
    
    const [containerImageList, setContainerImageList] = useState<DropdownType[]>([]);
    
    const [containerChangeYn, setContainerChangeYn] = useState(false);

    const [containerNameWarnYn, setContainerNameWarnYn] = useState(false);
    const [containerImageNameWarnYn, setContainerImageNameWarnYn] = useState(false);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                if(checkContainerData()) {
                    setExecuteUpdateYn(true);
                } else {
                    executeResult({successYn: false}, false, '');
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(props.args) {
            setContainerName(props.args?.pod_profile_container_name);
            setContainerImageName(props.args?.container_image_name);
            setContainerServiceTypeCode(props.args?.service_type_code)
            setRequestCpuCount(props.args?.request_cpu_count + "");
            setRequestMemoryCapacityMb(props.args?.request_memory_capacity_mb + "");
            setLimitsCpuCount(props.args?.limit_cpu_count + "");
            setLimitsMemoryCapacityMb(props.args?.limit_memory_capacity_mb + "");
            setGpuYn(props.args?.use_gpu_yn);
            if(props.args?.request_cpu_count > 0 || props.args?.request_memory_capacity_mb > 0 ||
                props.args?.limit_cpu_count > 0 || props.args?.limit_memory_capacity_mb > 0 ||
                gpuYn === true) {
                setResourceYn(true);
            } else {
                setResourceYn(false);
            } 
            setCommands(props.args?.commands);
            setVolumeMounts(props.args?.volume_mounts);
            setEnvs(props.args?.environments);
            setPorts(props.args?.ports);
            setLivenessYn(props.args?.liveness_probe_yn);
            if(props.args?.liveness_probe_commands) {
                setLivenessType("CMD");
            } else if(props.args?.liveness_probe_http_get_path && props.args?.liveness_probe_http_get_port > 0) {
                setLivenessType("HTTPGET");
            } else if(props.args?.liveness_probe_tcp_socket_port > 0) {
                setLivenessType("TCPSOCK");
            } else {
                setLivenessType("CMD");   
            }
            setLivenessCommands(props.args?.liveness_probe_commands);
            setLivenessHttpGetPath(props.args?.liveness_probe_http_get_path);
            setLivenessHttpGetPort(props.args?.liveness_probe_http_get_port + "");
            setLivenessHttpGetHeaders(props.args?.liveness_probe_http_get_headers);
            setLivenessTcpSocketPort(props.args?.liveness_probe_tcp_socket_port + "");
            setLivenessInitialDelaySecond(props.args?.liveness_probe_init_delay_sec + "");
            setLivenessPeriodSecond(props.args?.liveness_probe_period_sec + "");
            setLivenessTimeoutSecond(props.args?.liveness_probe_timeout_sec + "");
            setReadnessYn(props.args?.readiness_probe_yn);
            if(props.args?.readiness_probe_commands) {
                setReadnessType("CMD");
            } else if(props.args?.readiness_probe_http_get_path && props.args?.readiness_probe_http_get_port > 0) {
                setReadnessType("HTTPGET");
            } else if(props.args?.readiness_probe_tcp_socket_port > 0) {
                setReadnessType("TCPSOCK");
            } else {
                setReadnessType("CMD");   
            }
            setReadnessCommands(props.args?.readiness_probe_commands);
            setReadnessHttpGetPath(props.args?.readiness_probe_http_get_path);
            setReadnessHttpGetPort(props.args?.readiness_probe_http_get_port + "");
            setReadnessHttpGetHeaders(props.args?.readiness_probe_http_get_headers);
            setReadnessTcpSocketPort(props.args?.readiness_probe_tcp_socket_port + "");
            setReadnessInitialDelaySecond(props.args?.readiness_probe_init_delay_sec + "");
            setReadnessPeriodSecond(props.args?.readiness_probe_period_sec + "");
            setReadnessTimeoutSecond(props.args?.readiness_probe_timeout_sec + "");
        }
    }, [props.args]);


    useEffect(() => {
        if(stepIndex === 0) {
            loadContainerImageList();
        }
    }, [stepIndex]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdatePodProfileContainer();
        }
    }, [executeUpdateYn]);

    useEffect(() => {
        if(containerChangeYn) {
            setContainerChangeYn(false);
        }
    }, [containerChangeYn]);

    function checkContainerData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        setContainerNameWarnYn(false);
        setContainerImageNameWarnYn(false);
        let message = "";
        let error = false;
        
        if(!containerName || !containerImageName){
            message = t("MESSAGE_POD_PROFILE_CONTAINER_INFO_ENTER_ERROR_MESSAGE");
            if(!containerName) {
                setContainerNameWarnYn(true);
            }
            if(!containerImageName) {
                setContainerImageNameWarnYn(true);
            }
            error = true;
        }
        
        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;

    }



    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeUpdatePodProfileContainer() {
        

        const data = {
            remove_yn: false,
            pod_profile_container_id: props.args?.pod_profile_container_id,
            pod_profile_container_name: containerName,
            container_image_name: containerImageName,
            service_type_code: containerServiceTypeCode
        };
        if(resourceYn) {
            data['request_cpu_count'] = Number(requestCpuCount);
            data['request_memory_capacity_mb'] = Number(requestMemoryCapacityMb);
            data['limit_cpu_count'] = Number(limitsCpuCount);
            data['limit_memory_capacity_mb'] = Number(limitsMemoryCapacityMb);
            data['request_gpu_yn'] = gpuYn;
        } else {
            data['request_cpu_count'] = 0;
            data['request_memory_capacity_mb'] = 0;
            data['limit_cpu_count'] = 0;
            data['limit_memory_capacity_mb'] = 0;
            data['request_gpu_yn'] = false;
        }

        if(commands) {
            data['commands'] = commands;
        }

        if(envs) {
            data['environments'] = envs;
        }

        if(volumeMounts) {
            data['volume_mounts'] = volumeMounts;
        }

        if(ports) {
            data['ports'] = ports;
        }

        if(livenessYn) {
            data['liveness_probe_yn'] = true;
            if(livenessCommands) {
                data['liveness_probe_commands'] = livenessCommands;
            } else if (livenessHttpGetPath && Number(livenessHttpGetPort) > 0) {
                data['liveness_probe_http_get_path'] = livenessHttpGetPath;
                data['liveness_probe_http_get_port'] = Number(livenessHttpGetPort);
                if(livenessHttpGetHeaders) {
                    data['liveness_probe_http_get_headers'] = livenessHttpGetHeaders;
                }
            } else if (Number(livenessTcpSocketPort) > 0) {
                data['liveness_probe_tcp_socket_port'] = Number(livenessTcpSocketPort);
            } else {
                data['liveness_probe_yn'] = false;
                data['liveness_probe_commands'] = "";
                data['liveness_probe_http_get_path'] = "";
                data['liveness_probe_http_get_port'] = 0;
                data['liveness_probe_tcp_socket_port'] = 0;
            }
            if(data['liveness_probe_yn']) {
                data['liveness_probe_init_delay_sec'] = Number(livenessInitialDelaySecond);
                data['liveness_probe_period_sec'] = Number(livenessPeriodSecond);
                data['liveness_probe_timeout_sec'] = Number(livenessTimeoutSecond);
            }
        } else {
            data['liveness_probe_yn'] = false;
            data['liveness_probe_commands'] = "";
            data['liveness_probe_http_get_path'] = "";
            data['liveness_probe_http_get_port'] = 0;
            data['liveness_probe_tcp_socket_port'] = 0;
        }
        
        if(readnessYn) {
            data['readiness_probe_yn'] = true;
            if(readnessCommands) {
                data['readiness_probe_commands'] = readnessCommands;
            } else if (readnessHttpGetPath && Number(readnessHttpGetPort) > 0) {
                data['readiness_probe_http_get_path'] = readnessHttpGetPath;
                data['readiness_probe_http_get_port'] = Number(readnessHttpGetPort);
                if(readnessHttpGetHeaders) {
                    data['readiness_probe_http_get_headers'] = readnessHttpGetHeaders;
                }
            } else if (Number(readnessTcpSocketPort) > 0) {
                data['readiness_probe_tcp_socket_port'] = Number(readnessTcpSocketPort);
            } else {
                data['readiness_probe_yn'] = false;
                data['readiness_probe_commands'] = "";
                data['readiness_probe_http_get_path'] = "";
                data['readiness_probe_http_get_port'] = 0;
                data['readiness_probe_tcp_socket_port'] = 0;
            }
            if(data['readiness_probe_yn']) {
                data['readiness_probe_init_delay_sec'] = Number(readnessInitialDelaySecond);
                data['readiness_probe_period_sec'] = Number(readnessPeriodSecond);
                data['readiness_probe_timeout_sec'] = Number(readnessTimeoutSecond);
            }
        } else {
            data['readiness_probe_yn'] = false;
            data['readiness_probe_commands'] = "";
            data['readiness_probe_http_get_path'] = "";
            data['readiness_probe_http_get_port'] = 0;
            data['readiness_probe_tcp_socket_port'] = 0;
        }

        const updatePackageData = {
            pod_profile_containers: [data]
        }

        requests.put(PLATFORM_URL.POD_PROFILE + '/' + props.args?.podProfileId, updatePackageData)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }

    function loadContainerImageList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + props.args?.projectId + PLATFORM_URL.POD_IMAGE, {size: 9999})
        .then((response) => {
            const containerImages = response.data.items.map((data, index) => {
                return {
                    value: data.container_image_id,
                    label: data.image_path,
                }
            })
            
            setContainerImageList([{label: t("DIRECT_INPUT_TEXT"), value:""} ,...containerImages]);
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    
    function selectContainerImage(imageId){
        let label = "";
        if(!imageId) {
            setContainerImageId("");
        } else {

            for(const containerImage of containerImageList) {
                if(containerImage.value === imageId) {
                    label = containerImage.label;
                }
            }
            setContainerImageId(imageId);
            setContainerImageName(label);
        }
    }

    return (
            <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("MESSAGE_POD_PROFILE_CONTAINER_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    {
                        containerChangeYn === false ?
                        <View style={style.mainContainer}>
                            <View style={style.rowContainer}>
                                <CustomText text={t("CONTAINER_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput 
                                    key={101} 
                                    width={570} height={36} 
                                    value={containerName} 
                                    type={"text"} 
                                    activeYn={true} 
                                    inputCb={(v)=>{setContainerName(v)}} 
                                    warnYn={containerNameWarnYn} 
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <CustomText text={t("CONTAINER_IMAGE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={102} 
                                    width={540} height={36} 
                                    items={containerImageList}
                                    value={containerImageId} 
                                    setValue={(v)=>{selectContainerImage(v)}} 
                                    disable={false}
                                    defaultvalue={{label:t("DIRECT_INPUT_TEXT"), value:""}}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <CustomText text={t("IMAGE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput 
                                    key={103} 
                                    width={570} height={36} 
                                    value={containerImageName} 
                                    type={"text"} 
                                    activeYn={true} 
                                    inputCb={(v)=>{setContainerImageName(v)}} 
                                    warnYn={containerImageNameWarnYn} 
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <CustomText text={t("SERVICE_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={45}
                                    width={540} height={36}
                                    items={podServiceTypes}
                                    value={containerServiceTypeCode}
                                    setValue={(v)=>setContainerServiceTypeCode(v)}
                                    disable={false}
                                    defaultvalue={podServiceTypes[0]}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("RESOURCE_CHECK_TEXT")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={104}
                                    label={t("ACTIVE_TEXT")} 
                                    id={"ResourceCheckbox"} 
                                    checked={resourceYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={(e)=>{setResourceYn(!resourceYn)}}
                                />
                            </View>
                            {
                                resourceYn ?
                                <View style={{...style.AddInfoBox, marginTop: -10, height: 160, width: 520}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("REQUEST_CPU_TEXT")}
                                            </Text>
                                            <CustomTextInput
                                                key={105} 
                                                width={100} height={33} 
                                                value={requestCpuCount}
                                                type={"number"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setRequestCpuCount(v)}} 
                                                warnYn={false} 
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("REQUEST_MEMORY_TEXT")}(Mi)
                                            </Text>
                                            <CustomTextInput
                                                key={106} 
                                                width={100} height={33} 
                                                value={requestMemoryCapacityMb} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setRequestMemoryCapacityMb(v)}} 
                                                warnYn={false} 
                                            />
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("LIMIT_CPU_TEXT")}
                                            </Text>
                                            <CustomTextInput
                                                key={107} 
                                                width={100} height={33} 
                                                value={limitsCpuCount} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setLimitsCpuCount(v)}} 
                                                warnYn={false} 
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("LIMIT_MEMORY_TEXT")}(Mi)
                                            </Text>
                                            <CustomTextInput
                                                key={108} 
                                                width={100} height={33} 
                                                value={limitsMemoryCapacityMb} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setLimitsMemoryCapacityMb(v)}} 
                                                warnYn={false} 
                                            />
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("GPU_ACTIVE_TEXT")}
                                            </Text>
                                            <CustomSquareCheckBox
                                                size={104}
                                                label={t("ACTIVE_TEXT")} 
                                                id={"ResourceGpuCheckbox"} 
                                                checked={gpuYn}
                                                disabled={false}
                                                textStyle={{
                                                    fontFamily: FONT.REGULAR,
                                                    fontSize: "12px",
                                                    color: "#333"
                                                }}
                                                setCheckBoxStatus={(e)=>{setGpuYn(!gpuYn)}}
                                            />
                                        </View>
                                    </View>
                                </View>
                                :null
                            }
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("COMMAND_TEXT")}
                                </Text>
                                <CustomTextInput 
                                    key={152} 
                                    width={570} height={36} 
                                    value={commands} 
                                    type={"text"} 
                                    activeYn={true} 
                                    inputCb={(v)=>{setCommands(v)}} 
                                    warnYn={false} 
                                    placeHolderText={t("su,-c,echo SampleCommand")}
                                />
                            </View>
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("ENVIRONMENT_VARIABLE_TEXT")}
                                </Text>
                                <TextArea 
                                    key={153} 
                                    width={570} height={60} 
                                    value={envs} 
                                    type={"text"} 
                                    activeYn={true} 
                                    inputCb={(v)=>{setEnvs(v)}} 
                                    warnYn={false}
                                    placeHolderText={"ENV_1=VALUE_1\nENV_2=VALUE_1\n..."}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("CONTAINER_PORT_TEXT")}
                                </Text>
                                <CustomTextInput 
                                    key={154} 
                                    width={570} height={36} 
                                    value={ports} 
                                    type={"text"} 
                                    activeYn={true} 
                                    inputCb={(v)=>{setPorts(v)}} 
                                    warnYn={false} 
                                    placeHolderText={t("80,8080,443,8443...")}
                                />
                            </View>
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("CONTAINER_VOLUME_MOUNT_TEXT")}
                                </Text>
                                <TextArea 
                                    key={155} 
                                    width={570} height={60} 
                                    value={volumeMounts} 
                                    type={"text"} 
                                    activeYn={true} 
                                    inputCb={(v)=>{setVolumeMounts(v)}} 
                                    warnYn={false}
                                    placeHolderText={"VOL_NAME_1=MOUNT_PATH_1\nVOL_NAME_2=MOUNT_PATH_2\n..."}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("LivenessProbe")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={121}
                                    label={t("ACTIVE_TEXT")} 
                                    id={"LivenessCheckbox"} 
                                    checked={livenessYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={(e)=>{setLivenessYn(!livenessYn)}}
                                />
                            </View>
                            {
                                livenessYn ?
                                <View style={
                                    livenessType === "CMD" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : livenessType === "HTTPGET" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : {...style.AddInfoBox, marginTop: -10, height: 125, width: 520}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("PROBE_TYPE_TEXT")}
                                            </Text>
                                            <CustomDropDown
                                                key={122} 
                                                width={100} height={36} 
                                                items={probeExecTypes}
                                                value={livenessType} 
                                                setValue={(v)=>{setLivenessType(v)}} 
                                                disable={false}
                                                defaultvalue={{label:"Command", value:"CMD"}}
                                            />
                                        </View>
                                        { livenessType === "HTTPGET" || livenessType === "TCPSOCK"? 
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {livenessType === "HTTPGET" ? t("HTTP PORT") : t("TCP PORT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={126} 
                                                    width={100} height={33} 
                                                    value={livenessType === "TCPSOCK" ? livenessTcpSocketPort : livenessHttpGetPort} 
                                                    type={"text"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{livenessType === "TCPSOCK"? setLivenessTcpSocketPort(v) : setLivenessHttpGetPort(v)}} 
                                                    warnYn={false} 
                                                />
                                            </View>
                                            :null
                                        }
                                    </View>
                                    {
                                        livenessType === "HTTPGET"? 
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_PATH_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={137} 
                                                    width={125} height={33} 
                                                    value={livenessHttpGetPath} 
                                                    type={"text"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{setLivenessHttpGetPath(v)}} 
                                                    warnYn={false} 
                                                />
                                            </View>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_HEADER_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={138} 
                                                    width={100} height={33} 
                                                    value={livenessHttpGetHeaders} 
                                                    type={"text"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{setLivenessHttpGetHeaders(v)}} 
                                                    warnYn={false}
                                                    placeHolderText={"key=value,key=value"}
                                                />
                                            </View>
                                        </View>
                                    : livenessType === "CMD" ?
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("COMMAND_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={139} 
                                                width={350} height={36} 
                                                value={livenessCommands} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setLivenessCommands(v)}} 
                                                warnYn={false} 
                                                placeHolderText={t("su,-c,echo SampleCommand")}
                                            />
                                        </View>
                                    : null
                                    }
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("Initial Delay")}
                                            </Text>
                                            <CustomTextInput
                                                key={137} 
                                                width={55} height={33} 
                                                value={livenessInitialDelaySecond} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setLivenessInitialDelaySecond(v)}} 
                                                warnYn={false} 
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Period")}
                                            </Text>
                                            <CustomTextInput
                                                key={138} 
                                                width={50} height={33} 
                                                value={livenessPeriodSecond} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setLivenessPeriodSecond(v)}} 
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Timeout")}
                                            </Text>
                                            <CustomTextInput
                                                key={138} 
                                                width={50} height={33} 
                                                value={livenessTimeoutSecond} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setLivenessTimeoutSecond(v)}} 
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                    </View>
                                </View>
                                :null
                            }
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("ReadinessProbe")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={121}
                                    label={t("ACTIVE_TEXT")} 
                                    id={"ReadnessCheckbox"} 
                                    checked={readnessYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={(e)=>{setReadnessYn(!readnessYn)}}
                                />
                            </View>
                            {
                                readnessYn ?
                                <View style={
                                    readnessType === "CMD" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : readnessType === "HTTPGET" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : {...style.AddInfoBox, marginTop: -10, height: 125, width: 520}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("PROBE_TYPE_TEXT")}
                                            </Text>
                                            <CustomDropDown
                                                key={162} 
                                                width={100} height={36} 
                                                items={probeExecTypes}
                                                value={readnessType} 
                                                setValue={(v)=>{setReadnessType(v)}} 
                                                disable={false}
                                                defaultvalue={{label:"Command", value:"CMD"}}
                                            />
                                        </View>
                                        { readnessType === "HTTPGET" || readnessType === "TCPSOCK"? 
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {readnessType === "HTTPGET" ? t("HTTP PORT") : t("TCP PORT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={163} 
                                                    width={100} height={33} 
                                                    value={readnessType === "TCPSOCK" ? readnessTcpSocketPort : readnessHttpGetPort} 
                                                    type={"text"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{readnessType === "TCPSOCK"? setReadnessTcpSocketPort(v) : setReadnessHttpGetPort(v)}} 
                                                    warnYn={false} 
                                                />
                                            </View>
                                            :null
                                        }
                                    </View>
                                    {
                                        readnessType === "HTTPGET"? 
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_PATH_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={164} 
                                                    width={125} height={33} 
                                                    value={readnessHttpGetPath} 
                                                    type={"text"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{setReadnessHttpGetPath(v)}} 
                                                    warnYn={false} 
                                                />
                                            </View>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_HEADER_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={165} 
                                                    width={100} height={33} 
                                                    value={readnessHttpGetHeaders} 
                                                    type={"text"} 
                                                    activeYn={true} 
                                                    inputCb={(v)=>{setReadnessHttpGetHeaders(v)}} 
                                                    warnYn={false}
                                                    placeHolderText={"key=value,key=value"}
                                                />
                                            </View>
                                        </View>
                                    : readnessType === "CMD" ?
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("COMMAND_TEXT")}
                                            </Text>
                                            <CustomTextInput 
                                                key={166} 
                                                width={350} height={36} 
                                                value={readnessCommands} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setReadnessCommands(v)}} 
                                                warnYn={false} 
                                                placeHolderText={t("su,-c,echo SampleCommand")}
                                            />
                                        </View>
                                    : null
                                    }
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("Initial Delay")}
                                            </Text>
                                            <CustomTextInput
                                                key={137} 
                                                width={55} height={33} 
                                                value={readnessInitialDelaySecond} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setReadnessInitialDelaySecond(v)}} 
                                                warnYn={false} 
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Period")}
                                            </Text>
                                            <CustomTextInput
                                                key={138} 
                                                width={50} height={33} 
                                                value={readnessPeriodSecond} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setReadnessPeriodSecond(v)}} 
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Timeout")}
                                            </Text>
                                            <CustomTextInput
                                                key={138} 
                                                width={50} height={33} 
                                                value={readnessTimeoutSecond} 
                                                type={"text"} 
                                                activeYn={true} 
                                                inputCb={(v)=>{setReadnessTimeoutSecond(v)}} 
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                    </View>
                                </View>
                                :null
                            }
                        </View>
                    :null
                    }
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    topContainer: {
        
    },
    listMainContainer: {
        marginTop: 38,
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
        borderRadius: 10,
        borderColor: "#9ea0a5",
        borderWidth: 0.5,
        marginBottom: 20,
    },
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    AddInfoBox: {
        width: 580, height: 230,
        marginLeft: 150, marginTop: 20, marginBottom: 20,
        paddingLeft: 20, paddingTop: 20, paddingBottom: 20, paddingRight: 40,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
    },
    AddInfoColumnText: {
        width: 130,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    }
});